// Backend API Service - Comunicação com Vercel Serverless Functions

// Em produção Vercel, as functions ficam em /api
// Em desenvolvimento local, usar http://localhost:3000/api (frontend dev server proxy)
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

/**
 * Helper: faz fetch para a API e trata respostas HTML (dev server sem backend)
 * Retorna { ok, data } ou lança erro
 */
const safeFetch = async (url, options) => {
  const response = await fetch(url, options);

  // Detecta se a resposta é HTML (dev server retornando index.html em vez de JSON)
  const contentType = response.headers.get('content-type') || '';
  if (contentType.includes('text/html') || (!contentType.includes('application/json') && !response.ok)) {
    console.warn(
      '⚠️ API de email indisponível (ambiente local sem backend). O agendamento foi criado normalmente, apenas o email não foi enviado.'
    );
    return { ok: false, data: { error: 'Backend API não disponível em ambiente local' } };
  }

  const data = await response.json();
  return { ok: response.ok, data };
};

/**
 * Enviar email de novo agendamento para o dono da barbearia
 */
export const sendNewAppointmentEmail = async (appointment, barbershop, ownerEmail) => {
  try {
    const { ok, data } = await safeFetch(`${BACKEND_URL}/api/new-appointment`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ appointment, barbershop, ownerEmail })
    });

    if (!ok) {
      console.warn('Email de novo agendamento não enviado:', data.error);
      return { success: false, error: data.error };
    }

    console.log('✅ Email de novo agendamento enviado:', data);
    return { success: true, data: data.data };
  } catch (error) {
    console.warn('⚠️ Falha ao enviar email (agendamento não afetado):', error.message);
    return { success: false, error: error.message };
  }
};

/**
 * Enviar email de confirmação para o cliente
 */
export const sendConfirmationEmail = async (appointment, barbershop, clientEmail) => {
  try {
    const { ok, data } = await safeFetch(`${BACKEND_URL}/api/confirmation`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ appointment, barbershop, clientEmail })
    });

    if (!ok) {
      console.warn('Email de confirmação não enviado:', data.error);
      return { success: false, error: data.error };
    }

    console.log('✅ Email de confirmação enviado:', data);
    return { success: true, data: data.data };
  } catch (error) {
    console.warn('⚠️ Falha ao enviar email (confirmação não afetada):', error.message);
    return { success: false, error: error.message };
  }
};

/**
 * Enviar email de cancelamento
 */
export const sendCancellationEmail = async (appointment, barbershop, recipientEmail, cancelledBy) => {
  try {
    const { ok, data } = await safeFetch(`${BACKEND_URL}/api/cancellation`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ appointment, barbershop, recipientEmail, cancelledBy })
    });

    if (!ok) {
      console.warn('Email de cancelamento não enviado:', data.error);
      return { success: false, error: data.error };
    }

    console.log('✅ Email de cancelamento enviado:', data);
    return { success: true, data: data.data };
  } catch (error) {
    console.warn('⚠️ Falha ao enviar email (cancelamento não afetado):', error.message);
    return { success: false, error: error.message };
  }
};

/**
 * Enviar email de notificação da fila de espera
 */
export const sendWaitlistNotificationEmail = async (waitlistItem, barbershop, slot, userEmail) => {
  try {
    const { ok, data } = await safeFetch(`${BACKEND_URL}/api/waitlist-notification`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ waitlistItem, barbershop, slot, userEmail })
    });

    if (!ok) {
      console.warn('Email de fila de espera não enviado:', data.error);
      return { success: false, error: data.error };
    }

    console.log('✅ Email de fila de espera enviado:', data);
    return { success: true, data: data.data };
  } catch (error) {
    console.warn('⚠️ Falha ao enviar email (waitlist não afetada):', error.message);
    return { success: false, error: error.message };
  }
};

/**
 * Health check - não necessário com Vercel Functions
 */
export const checkBackendHealth = async () => {
  console.log('Vercel Serverless Functions - sempre disponível');
  return { success: true, data: { status: 'ok' } };
};
